/* global mixpanel */
export function translateInventoryCode (inventory) {
  switch (inventory) {
    case 1:
    case '1':
      return 'Low Stock Alert'
    case 2:
    case '2':
      return 'Out of Stock Alert'
    default:
      return 'All'
  }
}

export function ingredientLibraryStart ({outletIds, categoryIds, InventoryIds}) {
  mixpanel.track('Ingredient Library Start', {
    'Current Selected Outlet': outletIds,
    'Current Selected Category': categoryIds,
    'Current Selected Inventory': translateInventoryCode(InventoryIds)
  })
}

export function ingredientLibraryChangeFilter ({outletIds, categoryIds, inventoryIds}) {
  mixpanel.track('Ingredient Library Change Filter', {
    'Current Selected Outlet Filter': outletIds,
    'Current Selected Category Filter': categoryIds,
    'Current Selected Inventory Filter': translateInventoryCode(inventoryIds)
  })
}

export function ingredientLibrarySelect ({outletIds, name, category, unit}) {
  mixpanel.track('Ingredient Library Select', {
    'Current Selected Outlet': outletIds,
    'Name': name,
    'Category': category,
    'Unit': unit
  })
}

export function ingredientLibraryCreate ({ingredient, allOutlet}) {
  let eventName = ''
  if (allOutlet) {
    eventName = 'Ingredient Create All Outlet'
  } else {
    eventName = 'Ingredient Create One Outlet'
  }
  mixpanel.track(eventName, {
    'Name': ingredient.name,
    'Category': ingredient.ingredient_category_name,
    'Unit': ingredient.unit_name,
    'In Stock Current': ingredient.in_stock
  })
}

export function ingredientLibraryDelete ({outletIds, name, category, unit}) {
  mixpanel.track('Ingredient Library Delete', {
    'Current Selected Outlet': outletIds,
    'Name': name,
    'Category': category,
    'Unit': unit
  })
}

export function cogsTrackingIngredient ({ingredientList, libraryCOGSForm, showInputCOGS}) {
  let eventName = ''
  !showInputCOGS ? eventName = 'COGS Tracking Start Ingredient' : eventName = 'COGS Tracking Manage Ingredient'
  mixpanel.track(eventName, {
    'Ingredient [List]': ingredientList,
    'Name': ingredientList.name,
    'Average Cost': libraryCOGSForm.cogs
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/ingredient/library.js